import { render, staticRenderFns } from "./ProductDisposalEmissionByActivity.vue?vue&type=template&id=0ec6ebf6"
import script from "./ProductDisposalEmissionByActivity.vue?vue&type=script&lang=js"
export * from "./ProductDisposalEmissionByActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports